import InterestForm from "./InterestForm";

interface FloatingFormProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function FloatingForm({ isOpen, onClose }: FloatingFormProps) {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-[80] bg-black/60 flex items-end md:items-center justify-center">
      {/* Mobile: slide up from bottom */}
      <div
        className="w-full md:max-w-md bg-white rounded-t-xl md:rounded-xl max-h-[90vh] overflow-y-auto animate-fade-up"
        onClick={(e) => e.stopPropagation()}
      >
        {/* Header */}
        <div className="sticky top-0 bg-white z-10 flex items-center justify-between px-6 py-4 border-b border-background-200">
          <h3 className="text-lg font-bold text-foreground-900">관심고객등록</h3>
          <button
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center text-foreground-500 hover:text-foreground-700 cursor-pointer"
            aria-label="닫기"
          >
            <span className="w-6 h-6 flex items-center justify-center">
              <i className="ri-close-line text-xl"></i>
            </span>
          </button>
        </div>

        {/* Form */}
        <div className="px-6 py-6">
          <InterestForm formId="floating-interest-form" isFloating onClose={onClose} />
        </div>
      </div>
    </div>
  );
}